import axios from '../utils/axios';

export default function fetchRelevantCourseEnquiry(adminId,courseId,params) {
    return (
        axios.get('/admin/' + adminId +'/courses/course/' + courseId + '/relevant-leads',  {params} )
    )
}